import React, { useEffect } from 'react';

import { useTimer } from 'use-timer';
import { Button, Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { useLogout } from 'hooks';
import { toHHMMSS } from 'utils/Time';

interface ILogoutModalProps {
  show: boolean;
  extendSession: boolean;
  handleExtend: () => void;
}

const LogoutModal = ({ show, extendSession, handleExtend }: ILogoutModalProps) => {
  const intl = useIntl();
  const { logout } = useLogout();
  const { time, start, reset } = useTimer({
    endTime: 0,
    initialTime: 60,
    timerType: 'DECREMENTAL',
    onTimeOver: () => {
      logout();
    }
  });
  const description =
    (!extendSession ? intl.formatMessage({ id: 'sessionHasExpired' }) + ' ' : '') +
    intl.formatMessage({ id: 'logoutTimerKey' }, { timer: toHHMMSS(time).substring(3) });

  const handleClick = () => {
    if (extendSession) {
      handleExtend();
    } else {
      logout();
    }
  };

  useEffect(() => {
    reset();
    if (show) {
      start();
    }
  }, [show, extendSession, reset, start]);

  return (
    <Modal show={show} backdrop="static" data-test="idleModal">
      <Modal.Header>
        <Modal.Title>
          {intl.formatMessage({
            id: extendSession ? 'extendSessionQuestionkey' : 'sessionExpiredKey'
          })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{description}</p>
        <hr />
        <div className="text-right">
          <Button variant="primary" onClick={handleClick} data-test="idleModalContinue">
            {intl.formatMessage({ id: extendSession ? 'continueKey' : 'logoutKey' })}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LogoutModal;
